export default function ($) {
  $('.js-dynamic-section-trigger').on("mouseover click", function (event) {

    let wrapper = $(this).closest('.js-dynamic-section-wrapper')
    let contentIdentifier = $(this).data('target-identifier')
    let contentNode = $(".js-dynamic-section-content[data-content-identifier='" + contentIdentifier + "']")

    if (contentNode.length > 0) {
      let newPrimaryBgColorClass = contentNode.data('primary-background-color-class')
      wrapper.find('.js-dynamic-section-content').hide()
      contentNode.show()
      wrapper.removeClass(wrapper.data('current-primary-background-color-class'))
      wrapper.addClass(newPrimaryBgColorClass)
      wrapper.data('current-primary-background-color-class', newPrimaryBgColorClass)
    }
  })
}
